import request from "../api/request";

const login = ({ email, password }) => request().post("users/auth", { email, password });
const checkToken = () => request().get("users/me");
const getRentals = params => request().get("/rentals/manage", { params });
const getModels = () => request().get("/models/manage");
const changeModel = (id, model) => request().patch("/models/change", { id, model });
const createModel = (model) => request().post("/models/create", { model });
const deleteModel = (id) => request().patch("/models/delete", { id });
const changeRental = (id, change) => request().patch("/rentals/change", { id, change });
const createRental = (matricula, idModelo) => request().post("/rentals/create", { matricula, idModelo });
const getUsers = () => request().get("/users/manage");
const createUser = (user) => request().post("/users/register", { ...user });
const changeUser = (id, change) => request().patch("/users/change", { id, change });
const cancelBooking = (idPayment, refund) => request().post("/payments/cancel", { idPayment, refund });
const cancelBookingNoPay = (idBooking) => request().post("/payments/cancelBooking", { idBooking });
const changeBooking = (idBooking, pickUp, leaveIt, idUser, days) => request().patch("/bookings/change", { idBooking, pickUp, leaveIt, idUser, days});
const changeActiveBooking = (idBooking, active) => request().patch("/bookings/changeActive", { idBooking, active});
const changeBookingRental = (idBooking, idOldRental, idNewRental) => request().patch("/bookings/changeRental", { idBooking, idOldRental, idNewRental});
const createBookingNoPay = (pickUp, leaveIt, days, idUser, vespa, payMethod, price) => request().post("/bookings/noPay", { pickUp, days, leaveIt, idUser, vespa, payMethod, price});
const getSettings = () => request().get("/settings");
const changeSettings = (data) => request().patch("/settings/change", { data });

export {
  login,
  getRentals,
  checkToken,
  getModels,
  changeActiveBooking,
  changeBookingRental,
  changeModel,
  createModel,
  deleteModel,
  changeRental,
  createRental,
  changeBooking,
  getUsers,
  changeUser,
  createUser,
  cancelBooking,
  createBookingNoPay,
  cancelBookingNoPay,
  getSettings,
  changeSettings,
};
